<div class="onboarding">
    <div class="semi-background">
        <div class="col-md-10 mx-auto">
            
            <onboarding-header [step]="step"></onboarding-header>

            <div class="content mt-0 mt-md-3">
                <div class="animate__animated animate__slideInRight">
                    <div class="form-group title mt-3">
                        <h4 class="text-center">{{ 'onboarding.default_settings.description' | translate}}</h4>
                    </div>
                    
                    <form class="form-horizontal mt-3">
                        <team-defaults-settings-form #teamDefaultForm [team]="team" mode="create" (onSubmit)="next()"></team-defaults-settings-form>
                
                        <div class="form-group form-actions row">
                            <div class="col-md-8"></div>
                            <div class="col-md-2">
                                <button class="btn btn-primary btn-lg btn-next" data-cy="next-btn" type="submit" 
                                        [disabled]="teamDefaultForm.form.invalid"
                                        (click)="next()">
                                    {{'next' | translate}}  <i class="far fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>